import { render, staticRenderFns } from "./noticeEdit.vue?vue&type=template&id=190c12a7&scoped=true"
import script from "./noticeEdit.vue?vue&type=script&lang=js"
export * from "./noticeEdit.vue?vue&type=script&lang=js"
import style0 from "./noticeEdit.vue?vue&type=style&index=0&id=190c12a7&prod&lang=scss&scoped=true"
import style1 from "./noticeEdit.vue?vue&type=style&index=1&id=190c12a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c12a7",
  null
  
)

export default component.exports